import { useEffect, useState } from 'react'
import { STABILITY_EVENT } from '../utils/runtimeStability'

interface StabilityDetail {
  type: 'chunk-error' | 'version-mismatch'
  message: string
  currentBuildId: string | null
  latestBuildId?: string | null
}

export default function RuntimeStabilityBanner() {
  const [issue, setIssue] = useState<StabilityDetail | null>(null)

  useEffect(() => {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<StabilityDetail>
      setIssue(customEvent.detail)
    }

    window.addEventListener(STABILITY_EVENT, handler as EventListener)
    return () => {
      window.removeEventListener(STABILITY_EVENT, handler as EventListener)
    }
  }, [])

  if (!issue) {
    return null
  }

  const isVersionMismatch = issue.type === 'version-mismatch'

  return (
    <div
      style={{
        position: 'fixed',
        right: '16px',
        bottom: '16px',
        zIndex: 9999,
        width: 'min(420px, calc(100vw - 32px))',
        background: isVersionMismatch ? '#1d4ed8' : '#991b1b',
        color: '#fff',
        borderRadius: '12px',
        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.25)',
        padding: '16px'
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: '8px' }}>
        {isVersionMismatch ? 'Yeni Sürüm Hazır' : 'Uygulama Dosyası Yüklenemedi'}
      </div>
      <div style={{ fontSize: '14px', lineHeight: 1.5, opacity: 0.95 }}>
        {issue.message}
      </div>
      {issue.latestBuildId && (
        <div style={{ fontSize: '12px', marginTop: '8px', opacity: 0.8 }}>
          Yeni build: {issue.latestBuildId}
        </div>
      )}
      <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: '#fff',
            color: '#111827',
            border: 'none',
            borderRadius: '8px',
            padding: '10px 14px',
            fontWeight: 600,
            cursor: 'pointer'
          }}
        >
          Tam Yenile
        </button>
        <button
          onClick={() => setIssue(null)}
          style={{
            background: 'transparent',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.45)',
            borderRadius: '8px',
            padding: '10px 14px',
            fontWeight: 600,
            cursor: 'pointer'
          }}
        >
          Kapat
        </button>
      </div>
    </div>
  )
}
